import { render, staticRenderFns } from "./HospitalIncidentGallery.vue?vue&type=template&id=e94649b8&"
import script from "./HospitalIncidentGallery.vue?vue&type=script&lang=js&"
export * from "./HospitalIncidentGallery.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports